module.exports = __webpack_public_path__ + "img/jersey.fd6e41ec.svg";